import { TemplateElement, defineElement, html, i18n } from '@webtides/element-js';
import { reCaptchaStore } from './ReCaptchaStore';
import { renderValidationMessage } from './validationMessage.template';
import { ucStore } from '../../../../js/util/UserCentrics';
import style from './recaptcha-field.css';

export default class RecaptchaField extends TemplateElement {
    $form;

    constructor() {
        super({ styles: [style] });
    }

    async connected() {
        super.connected();
        if (this.interceptSubmit) {
            this.$form = document.getElementById(this.form) ?? this.closest('form');
            this.$form.addEventListener('submit', e => this.onSubmit(e));
        }
        reCaptchaStore.loadScript();
    }

    disconnected() {
        document.removeEventListener('submit', this.onSubmit);
    }

    properties() {
        return {
            token: 'initial',
            name: 'captcha',
            validationState: null,
            interceptSubmit: true,
            ucStore,
        };
    }

    events() {
        return {
            '[ref=consent]': {
                click: () => ucStore.openConsentLayer(),
            },
        };
    }

    async onSubmit(e) {
        e.preventDefault();
        await this.setToken();
        this.$form.submit();
    }

    watch() {
        return {
            ucStore: () => {
                this.validationState = '';
            },
        };
    }

    async setToken() {
        try {
            this.validationState = '';
            this.token = await reCaptchaStore?.execute();
            await this.requestUpdate();
        } catch (e) {
            this.validationState = 'TECH_FAIL';
            throw new Error('Failed');
        }
    }

    consentTemplate() {
        return html`
            <div class="flex">
                <input type="hidden" name="${this.name}" value="${this.token}" />
                <p class="p-2">
                    This site is protected by reCAPTCHA and the Google
                    <a class="text-link" href="https://policies.google.com/privacy">Privacy Policy</a> and
                    <a class="text-link" href="https://policies.google.com/terms">Terms of Service</a> apply.
                </p>
            </div>
            ${this.validationState ? renderValidationMessage(this.validationState) : ''}
        `;
    }

    consentRequiredTemplate() {
        return html`
            <div class="flex">
                <p class="p-2">
                    ${i18n('form.field.recaptcha.consent.required.label', '')}
                    – <button ref="consent" type="button" class="text-link">${i18n(
                        'form.field.recaptcha.consent.required.cta',
                        'Jetzt zustimmen'
                    )}<button>
               </p>
            </div>
            ${this.validationState ? renderValidationMessage(this.validationState) : ''}
        `;
    }

    template() {
        return html` ${reCaptchaStore.enabled && ucStore.isInitialized && ucStore.hasGoogleReCaptcha
            ? this.consentTemplate()
            : this.consentRequiredTemplate()}`;
    }
}
defineElement('recaptcha-field', RecaptchaField);
